import {
  Box,
  Typography,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import BoltIcon from '@mui/icons-material/Bolt';

export const GPTSelector = ({
  selectedGptId,
  onSelectGPT,
  onCloseMobile,
  customGpts = [],
  apiUrl
}) => {
  const handleSelectGPT = (gptId) => {
    onSelectGPT(gptId);
    // Close mobile sidebar after selection
    if (window.innerWidth <= 768 && onCloseMobile) {
      onCloseMobile();
    }
  };
  return (
    <Box sx={{ px: 1.5, pt: 1.5, pb: 2, borderBottom: 1, borderColor: 'divider' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 0.5, pb: 1.5 }}>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          GPTs
        </Typography>
        <Link
          href="/manage-gpts.html"
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: '0.75rem',
            fontWeight: 500,
            color: 'text.primary',
            '&:hover': { color: 'text.secondary' },
          }}
        >
          <EditIcon sx={{ fontSize: 12 }} />
          <span>Manage</span>
        </Link>
      </Box>

      {/* GPT List */}
      <List disablePadding sx={{ '& .MuiListItemButton-root': { borderRadius: 1, mb: 0.25 } }}>
        {/* Default Chat Option */}
        <ListItemButton
          selected={selectedGptId === '' || !selectedGptId}
          onClick={() => handleSelectGPT('')}
          sx={{
            py: 0.75,
            px: 1,
            '&.Mui-selected': {
              bgcolor: 'action.selected',
              '&:hover': { bgcolor: 'action.selected' },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Avatar
              sx={{
                width: 24,
                height: 24,
                background: 'linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)',
              }}
            >
              <ChatBubbleOutlineIcon sx={{ fontSize: 14, color: 'white' }} />
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary="General GPT"
            primaryTypographyProps={{
              variant: 'body2',
              fontWeight: 500,
              noWrap: true,
            }}
          />
        </ListItemButton>

        {/* Custom GPTs */}
        {customGpts.map((gpt) => (
          <ListItemButton
            key={gpt.id}
            selected={selectedGptId === gpt.id}
            onClick={() => handleSelectGPT(gpt.id)}
            sx={{
              py: 0.75,
              px: 1,
              '&.Mui-selected': {
                bgcolor: 'action.selected',
                '&:hover': { bgcolor: 'action.selected' },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              {gpt.favicon_url ? (
                <Avatar
                  src={`${apiUrl}${gpt.favicon_url}?t=${Date.now()}`}
                  alt={gpt.name}
                  sx={{ width: 24, height: 24 }}
                />
              ) : (
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    background: 'linear-gradient(135deg, #9333ea 0%, #ec4899 100%)',
                  }}
                >
                  <BoltIcon sx={{ fontSize: 14, color: 'white' }} />
                </Avatar>
              )}
            </ListItemIcon>
            <ListItemText
              primary={gpt.name}
              primaryTypographyProps={{
                variant: 'body2',
                fontWeight: 500,
                noWrap: true,
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};
